import { dangerousAxiosInstanceUseOnlyIfNeeded } from '@lumapps/base-api';
import { DEV_CDN } from '@lumapps/constants';

import { VersionMetadata } from '../types';

export interface GetMetadataForFrontendVersionOptions {
    version?: string | null;
}

export const getMetadataForFrontendVersion = (
    { version }: GetMetadataForFrontendVersionOptions,
    signal?: AbortSignal,
) =>
    dangerousAxiosInstanceUseOnlyIfNeeded.get<VersionMetadata>(`${DEV_CDN}${version}/statics/deploy-metadata.json`, {
        signal,
    });
